import PropTypes from 'prop-types'
import styled from 'styled-components'

export const StyledDivider = styled.div`
	width: ${({ width }) => width ? width + 'px' : '100%'};
	background-color: ${({ theme, inverted, color }) => color ? color : inverted ? theme.darkbgColor : '#fff'};
	height: ${({ visible }) => visible ? '1px' : '0px'};
	margin: ${({ height }) => height / 2}px 0px;
`

StyledDivider.defaultProps = {
	height: 40
}

StyledDivider.propTypes = {
	height: PropTypes.number,
	visible: PropTypes.bool,
	inverted: PropTypes.bool
}

export default StyledDivider
